<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 用户管理 / 查看下级用户</span>
      </div>
<!--      <div style="overflow:hidden; padding:15px 0px;">-->
<!--        <div @click="addAdmin" class="addBtn">返回用户列表</div>-->
<!--      </div>-->
      <div style="padding-top: 5px; color: #606266">
        <div>
          <h3>团队统计（包括自己）</h3>
        </div>
        <div style="text-align: left">
          <table width="100%">
            <tr>
              <th style="padding: 10px; background-color: #f8f8f8">团队总数</th>
              <th style="padding: 10px; background-color: #f8f8f8">投资总额</th>
              <th style="padding: 10px; background-color: #f8f8f8">充值总额</th>
              <th style="padding: 10px; background-color: #f8f8f8">提现总额</th>
            </tr>
            <tr>
              <td style="padding: 10px; background-color: #ffffff">{{ data.data.userCount }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.data.invest }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.data.topUp }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.data.withDraw }}</td>
            </tr>
          </table>
        </div>

        <div style="padding-top: 15px;">
          <h3>下级会员数（包括自己）</h3>
        </div>
        <div style="padding-top: 15px;">
          <div>
            <table width="100%">
              <tr>
                <th class="th">
                  ID
                </th>
                <th class="th">
                  账号
                </th>
                <th class="th">
                  姓名
                </th>
                <th class="th">
                  手机号码
                </th>
                <th class="th">投资总额</th>
                <th class="th">充值总额</th>
                <th class="th">提现总额</th>
              </tr>
              <tr :key="index" v-for="(value,index) in data.userList">
                <td class="td">
                  {{value.id}}
                </td>
                <td class="td" style="min-width: 50px;">
                  {{ value.account }}
                </td>
                <td class="td">
                  {{ value.name }}
                </td>
                <td class="td">
                  {{ value.phone }}
                </td>
                <td class="td">{{ value.invest }}</td>
                <td class="td">{{ value.topUp }}</td>
                <td class="td">{{ value.withDraw }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "ChildUser",
  data(){
    return{
      data:null
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    axiosGet(DO_NET_URL+"dataCount/GetChilidUser?code="+localStorage.getItem("userCode"),function (res){
      res=res.data
      console.log(res)
      that.data=res
    })
  },
  methods: {
    addAdmin(){
      this.$emit("send",'userList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>